module.exports = __webpack_public_path__ + "img/6.ee697dac.jpg";